import { defineRule, configure } from 'vee-validate'
import { required, min, max, min_value, numeric, one_of, confirmed } from '@vee-validate/rules'
import { localize } from '@vee-validate/i18n'
import i18n from '@/plugins/i18n'
import { type i18nTranslation, PrefixTranslationsEnum } from '@/common/types/i18n'

const uuidRegex = /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i
const uuid = (value: string) => {
  return uuidRegex.test(value)
}

const codeRegex = /^[a-zA-Z0-9-_]+$/
const codeRule = (value: string) => {
  return codeRegex.test(value)
}

defineRule('required', required)
defineRule('min', min)
defineRule('min_value', min_value)
defineRule('max', max)
defineRule('numeric', numeric)
defineRule('one_of', one_of)
defineRule('uuid', uuid)
defineRule('codeRule', codeRule)
defineRule('confirmed', confirmed)

const convertI18nLabelIntoVeevalidateFormat = () => {
  const i18nMessages = i18n.global.getLocaleMessage(i18n.global.locale.value) as Record<string, string>
  const messages: i18nTranslation = {}
  for (const messageKey in i18nMessages) {
    if (messageKey.startsWith(PrefixTranslationsEnum.VEEVALIDATE)) {
      const ruleKey = messageKey.replace(`${PrefixTranslationsEnum.VEEVALIDATE}.`, '')
      messages[ruleKey] = i18nMessages[messageKey]
    }
  }
  return messages
}

export const initFormValidation = async (locale: string) => {
  const messages = convertI18nLabelIntoVeevalidateFormat()

  configure({
    generateMessage: localize(locale, {
      messages,
    }),
  })
}
